import { getStandardReturnHistory, GetStandardReturnHistoryAPIParameter, GetStandardReturnHistoryParameter, StandardReturnStatusResult } from "@dana/Services/StandardReturnStatusService";

import { StandardReturnHistotyStateActions } from "@dana/Store/Data/StandardReturnsStatus/Reducers/StandardReturnsStatusReducer";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner, HasOnError } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = ApiHandlerDiscreteParameter<
    GetStandardReturnHistoryParameter & HasOnError<string>,
    GetStandardReturnHistoryAPIParameter,
    StandardReturnStatusResult,
    DispatchProp<StandardReturnHistotyStateActions>
>;

function setUrlSearchParams(params: Record<string, any>) {
    const url = new URL(window.location.href);

    // First, remove keys from searchParams that are not in params
    const currentKeys = Array.from(url.searchParams.keys());
    currentKeys.forEach((key) => {
        if (!(key in params)) {
            url.searchParams.delete(key);
        }
    });

    // Then, update or delete based on param values
    Object.entries(params).forEach(([key, value]) => {
        if (value != null && value !== "") {
            url.searchParams.set(key, value.toString());
        } else {
            url.searchParams.delete(key);
        }
    });
    window.history.replaceState({}, "", url.toString());
}

export const DispatchSetParameters: HandlerType = props => {
    props.dispatch({
        type: "StandardReturnsHistory/IsLoading",
        isLoading: true,
    });
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.apiParameter,
        ...props.parameter
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    setUrlSearchParams(props.apiParameter);
    try {
        props.apiResult = await getStandardReturnHistory(props.apiParameter);
    } catch (error) {
        if (error.status === 404 || error.status === 403) {
            props.parameter.onError?.(error.errorMessage);
            return;
        }
        if (error.status === 500) {
            props.parameter.onError?.("500");
            return;
        }
        throw error;
    }
};
export const LoadCreditMemosResponse: HandlerType = props => {
    props.dispatch({
        type: "StandardReturnsHistory/LoadData",
        standardReturns: props.apiResult.orders,
        pagination: props.apiResult.pagination,
    });

    props.dispatch({
        type: "StandardReturnsHistory/IsLoading",
        isLoading: false,
    });
};

export const chain = [DispatchSetParameters, PopulateApiParameter, RequestDataFromApi, LoadCreditMemosResponse];

const getStandardReturnOrders = createHandlerChainRunner(chain, "StandardReturnsStatusHandler");
export default getStandardReturnOrders;